import { useNavigate, useSearchParams } from "react-router-dom";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { useGetStoresMappingList } from "../../../../../hooks/api/queries/useMarketPlace";
import { useTable } from "react-table";
import { useContext, useMemo, useState } from "react";
import primaryComponents from "../../../../../components/primaryComponents";
import Icon from "../../../../../assets/icons";
import { pathConstants } from "../../../../../routes/pathContants";
import { useMutation, useQueryClient } from "react-query";
import { ToastContext } from "../../../../../hooks/context";
import { deleteMarketplaceStoresMapping } from "../../../../../services/marketplace";
import { defaultDateDisplay } from "../../../../../helpers";

export const useAllConnections = () => {
  const navigate = useNavigate();
  const { gotoPage } = useUrlSearch();
  const queryClient = useQueryClient();
  const triggerToast = useContext(ToastContext);

  const [search, setSearch] = useSearchParams();

  const queryText = search.get("query");

  const [deleteConnection, setDeleteConnection] = useState(null);

  const { data: storesMappingList } = useGetStoresMappingList({
    queries:
      queryText && queryText.length > 0
        ? `?marketplace_type=CHOWDECK&query=${queryText}`
        : "?marketplace_type=CHOWDECK",
  });

  const deleteStoresMapping = useMutation({
    mutationFn: (id) => deleteMarketplaceStoresMapping(id),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["storesMappingList"] });
      triggerToast(data.data.detail, "success");
      setDeleteConnection(null);
    },
    onError: (error) => {
      triggerToast(`${error.response.data.message}`, "warning");
    },
  });

  const searchConncections = (value) => {
    if (value.length === 0) search.delete("query");
    else search.set("query", value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const handleDeleteConnection = () => {
    deleteStoresMapping.mutate(deleteConnection);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Lumi Business Store",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span>{row?.original?.lumi_store?.name || "N/A"}</span>
        ),
      },
      {
        Header: "Chowdeck Store",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span>{row?.original?.marketplace_store_name || "N/A"}</span>
        ),
      },
      {
        Header: "No of Linked Products",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span>{row?.original?.mapped_products}</span>
        ),
      },
      {
        Header: "Date Created",
        accessor: "created_at",
        Cell: ({ cell: { row } }) => (
          <span>{defaultDateDisplay(row?.original?.created_at) || "N/A"}</span>
        ),
      },
      // {
      //   Header: "Last Updated",
      //   accessor: "updated_at",
      //   Cell: ({ cell: { row } }) => (
      //     <span>
      //       {new Date(row?.original?.updated_at).toLocaleString("en-us") ||
      //         "N/A"}
      //     </span>
      //   ),
      // },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <div className="d-flex" style={{ gap: "8px", width: 185 }}>
            <primaryComponents.Button
              classNames={"btn btn--primary smallBtn"}
              onClick={() =>
                navigate(
                  `${pathConstants.APPS_CHOWDECK_CONNECTIONS_EDIT({
                    id: row?.original?.marketplace_conn?.id,
                  })}?mapping_id=${row?.original?.id}`,
                )
              }
            >
              Update
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames={"btn btn--outline smallBtn"}
              onClick={() =>
                navigate(
                  `${pathConstants.APPS_CHOWDECK_API_MANAGEMENT}?id=${row?.original?.marketplace_conn?.id}`,
                )
              }
            >
              Manage API
            </primaryComponents.Button>
            <primaryComponents.Button
              onClick={() => setDeleteConnection(row?.original?.id)}
              classNames={"btn btn--outline-red smallBtn"}
              style={{ width: "12px" }}
            >
              <img src={Icon.deleteIcon} alt="" />
            </primaryComponents.Button>
          </div>
        ),
      },
    ],
    [storesMappingList?.data],
  );

  const instance = useTable({ columns, data: storesMappingList?.data || [] });

  return {
    search,
    storesMappingList: storesMappingList?.data,
    metaDetails: storesMappingList?.meta,
    instance,
    deleteStoresMapping,
    deleteConnection,
    setDeleteConnection,
    handleDeleteConnection,
    gotoPage,
    searchConncections,
  };
};
